export default __webpack_public_path__ + "img/pega-seo-legacy-app-modernization-carousel.8aab639e.png";